"use strict";
// tslint:disable
/**
 * Speedtest Plus API
 * This is the API for Speedtest Plus
 *
 * The version of the OpenAPI document: 0.30.0
 * Contact: speedtest-api@anw.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=ClientModel.js.map